import { Controller } from '@hotwired/stimulus'

// Suggestion chips for brand / tags / fee presets on workspace forms.
export default class extends Controller {
  pick (event) {
    const btn = event.currentTarget
    const fieldId = btn.dataset.workspaceChipField
    const value = btn.dataset.workspaceChipValue
    const mode = (btn.dataset.workspaceChipMode || 'replace').toLowerCase()
    if (!fieldId || value === undefined || value === null) return

    const el = document.getElementById(fieldId)
    if (!el) return

    const cur = (el.value || '').trim()
    if (mode === 'append') {
      const parts = cur ? cur.split(',').map((part) => part.trim()).filter(Boolean) : []
      if (!parts.some((part) => part.toLowerCase() === value.toLowerCase())) {
        parts.push(value)
      }
      el.value = parts.join(', ')
    } else {
      el.value = value
    }

    el.dispatchEvent(new Event('input', { bubbles: true }))
    el.dispatchEvent(new Event('change', { bubbles: true }))
    el.focus()
  }
}
